import React from 'react';
import { capitalizeFirstLetter } from '../../../util/helperFunctions';
import { Title } from 'bloomer/lib/elements/Title';
import Bold from '../../Bold';

export default function CountPreamble({
	startDate,
	endDate,
	animalCountArray,
	animalCountAverage,
	colorCodeMode,
	colors,
	animalType
}) {
	return (
		<div>
			<Title tag="h4">
				{colorCodeMode ?
					`${capitalizeFirstLetter(animalType)}s on the list broken down by color code:` :
					`${capitalizeFirstLetter(animalType)}s on the list each day:`}
			</Title>
			{colorCodeMode ? (
				<p>
					{/* Color Code Mode On */}
					Between <Bold>{startDate}</Bold> and{' '}
					<Bold>{endDate}</Bold> the number of {animalType}s on the
					enrichment list broken down by color code is as follows:
				</p>
			) : (
				<p>
					{/* Single number mode */}
					Between <Bold>{startDate}</Bold> and{' '}
					<Bold>{endDate}</Bold> the number of {animalType}s on the
					enrichment list fell between{' '}
					<Bold>{Math.min(...animalCountArray)}</Bold> and{' '}
					<Bold>{Math.max(...animalCountArray)}</Bold> {animalType}s. The
					Average was <Bold>{Math.floor(animalCountAverage)}</Bold>.
				</p>
			)}
		</div>
	);
}
